module.exports = __webpack_public_path__ + "img/doc_5.3374a9c3.png";